import { render, staticRenderFns } from "./contenidoEmpresas.vue?vue&type=template&id=05f69899&"
import script from "./contenidoEmpresas.vue?vue&type=script&lang=js&"
export * from "./contenidoEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports